var exports = {
  "Gt": "OtherAccountAvatar.module__frame___TWVrOG",
  "z5": "OtherAccountAvatar.module__cutout___TWVrOG",
  "qS": "OtherAccountAvatar.module__badge___TWVrOG",
  "Nw": "OtherAccountAvatar.module__badgeHighlighted___TWVrOG",
  "rF": "OtherAccountAvatar.module__badgeIcon___TWVrOG",
};

module.exports = exports;
